import React, {useState, Fragment, useCallback, useEffect} from 'react';
import { useForm } from 'react-hook-form';
import { Card, CardBody, CardHeader, Form, FormGroup, Input, Row, Col, Label  } from 'reactstrap';
import { Breadcrumbs, Btn, H4 } from '../../../../AbstractElements';
import DataTable from 'react-data-table-component';
// import { inventoryCategory, inventorytableColumns } from '../../../../Data/GeneralSettings';
import { toast } from 'react-toastify';
import SweetAlert from 'sweetalert2';
import RequiredField from '../../../../Constant';
import CommonModal from '../../../Common/Component/CommonModal';
import { CreateInventoryCategory, DeleteInventoryCategory, InventoryCategoryList, UpdateInventoryCategory } from '../../../../apiController';
import { roles_permissions } from '../../../../Layout/Sidebar/Menu';
const InventoryCategory = () =>{
  const [Large, setLarge] = useState(false);
  const permission = roles_permissions.find(module=> module.module_name === "Inventory Category")

  const LargeModaltoggle = () => {setLarge(!Large);reset({inventorycategory:''})};

  const [formdata, setFormdata] = useState({});
  const [inventory, setInventory] = useState([]);


  const {
    register,
    handleSubmit,
    formState: { errors },
    reset
  } = useForm();
  const [searchKeyword, setSearchKeyword] = useState('');
  const handleSearchKeyword = (keyword) => {
      setSearchKeyword(keyword);
      // searchMember(keyword);
  };

  const handleEdit = (row) => {
    console.log(row)
    setFormdata({ id: row.id, inventorycategory: row.name });
    setLarge(!Large);
    reset({ inventory: row.name });
  };

  
 const inventoryCategory = inventory.map((row, ind) => (
  {
      ind: ind + 1,
      id: row.id,
      inventorycategory: row.name,
      action:  (
          <span>
              <Btn
                  attrBtn={{
                      style:  {width: 60, fontSize: 14, padding: 4 },
                      color: 'success',
                      className: 'btn btn-xs',
                      type: 'button',
                      onClick:  () => handleEdit(row)
                  }}
              >
                  Edit
              </Btn>
          </span>
      )
  }
 ));

 const inventorytableColumns = [
  {
      name: '#',
      selector: row => row['ind'],
      sortable: true,
      center: false,
  },
  {
      name: 'Category',
      selector: row => row['inventorycategory'],
      sortable: true,
      center: false,
  },
  // {
  //     name: 'Action',
  //     selector: row => row.action,
  //     sortable: false,
  //     center: true,
  // },
];

if(permission?.edit_access){
  inventorytableColumns.push({
    name: "Action",
    selector: (row) => row["action"],
    sortable: false,
    center: true,
  });
}

  const [selectedRows, setSelectedRows] = useState([]);
    const [toggleDelet, setToggleDelet] = useState(false);
    const [data, setData] = useState(inventoryCategory);

  


    // const handleSaveForm = async (formdata) => {
    //   const formattedData = {
    //     // ...data,
    //     "name": formdata.inventorycategory,
    //     "id": formdata.id
    //   };
    //   delete formattedData.inventorycategory;
    //   console.log(formattedData)
  
    //   try {
    //     if (formattedData.id) {
    //       const response = await UpdateInventoryCategory(formattedData);
    //       if (response.status === true) {
    //         setInventory(prev => prev.map(item => item.id === formdata.id ? { ...item, name: formattedData.name } : item));
    //         toast.success('Updated Successfully!', { position: toast.POSITION.TOP_CENTER });
    //       }
    //       fetchInventoryCategory();
    //     } else {
    //       const response = await CreateInventoryCategory(formattedData);
    //       if (response.status === true) {
    //         toast.success('Created Successfully!', { position: toast.POSITION.TOP_CENTER });
    //         setInventory(prev => [...prev, response.data]);
    //         LargeModaltoggle()
    //       }
    //       fetchInventoryCategory();
    //     }
    //   } catch (error) {
    //     toast.error('An error occurred!', { position: toast.POSITION.TOP_CENTER });
    //   }
    //   reset({inventorycategory:''})
    // };

    const handleSaveForm = async (data) => {
      const formattedData = {
          name: data.inventorycategory,
          id: formdata.id
      };
  
      try {
          if (formdata.id) {
              const response = await UpdateInventoryCategory(formattedData);
              if (response.status === true) {
                setInventory(prev => prev.map(item => item.id === formdata.id ? { ...item, name: formattedData.name } : item));
                toast.success('Updated Successfully!', { position: toast.POSITION.TOP_CENTER });
                setTimeout(() => {
                  window.location.reload();
                  }, 2000);
              }
          } else {
              const response = await CreateInventoryCategory(formattedData);
              if (response.status === true) {
                setInventory(prev => [...prev, response.data]);
                  toast.success('Created Successfully!', { position: toast.POSITION.TOP_CENTER });
              }
          }
          fetchInventoryCategory();
          LargeModaltoggle();
      } catch (error) {
          toast.error('An error occurred!', { position: toast.POSITION.TOP_CENTER });
      }
      reset({inventorycategory:''})
  };
    const handleRowSelected = useCallback(state => {
        setSelectedRows(state.selectedRows);
    }, []);

    const handleDelete = async () => {
      const result = await SweetAlert.fire({
        title: 'Are you sure you want to delete?',
        cancelButtonText: 'No!',
        confirmButtonText: 'Yes!',
        reverseButtons: true,
        showCancelButton: true,
      });
    
      if (result.isConfirmed) {
        try {
          const selectedIds = selectedRows.map(row => row.id); 
          await Promise.all(selectedIds.map(id => DeleteInventoryCategory(id)));
          setInventory(inventory.filter(item => !selectedIds.includes(item.id)));
          setSelectedRows([]);
          toast.success('Deleted Successfully!', { position: toast.POSITION.TOP_CENTER });
          fetchInventoryCategory()
        } catch (error) {
          toast.error('An error occurred!', { position: toast.POSITION.TOP_CENTER });
        }
      }
    };
    


    const fetchInventoryCategory = async () => {
      const response = await InventoryCategoryList();
      if (response.status === true) {
        setInventory(response.data);
      }
    };

    useEffect(()=>{
      fetchInventoryCategory()
    },[])
  return (
    <Card>
      <Breadcrumbs mainTitle='Inventory Category' parent='Dashboard' title='inventorycategory' />
      <CardHeader className='card-no-border'>
        <div className='header-top'>
          <Fragment>
  <div className="search">
    <Form className="theme-form">
      <FormGroup className="form-group">
        <div className="input-group">
          <Input
            className="form-control"
            type="text"
            placeholder="search"
            defaultValue={searchKeyword}
            onChange={(e) => handleSearchKeyword(e.target.value)}
          />
          <div className="input-group-append">
            <span className="input-group-text">
              <i className="fa fa-search"></i>
            </span>
          </div>
        </div>
      </FormGroup>
    </Form>
  </div>
</Fragment>
          <div className='card-header-right-icon'>
            {/* <DropdownCommon dropdownMain={{ className: 'icon-dropdown', direction: 'start' }} options={DailyDropdown} iconName='icon-more-alt' btn={{ tag: 'span' }} /> */}
            <div className='card-header-right-icon'>
            <Btn attrBtn={{ color: 'light-primary', className: 'btn badge-light-primary', onClick: LargeModaltoggle }}>+ Add Inventory Category</Btn>
            <CommonModal isOpen={Large} title={"Inventory Category"} toggler={LargeModaltoggle} size="lg" onSave={handleSubmit(handleSaveForm)} formdata={formdata}>
              <Row>
            <Col sm="12">
            <FormGroup className="mb-3">
              <Label htmlFor="fname">{"Inventory Category"} <RequiredField/></Label>
              <input className={`form-control ${errors.inventorycategory && "is-invalid"}`} id="inventorycategory" type="text" name="inventorycategory" defaultValue={formdata.inventorycategory || ""} {...register("inventorycategory", { required: true })} />
              <span className="text-danger">{errors.inventorycategory && "Inventory Category is required"}</span>
            </FormGroup>
            </Col>
            </Row>
            </CommonModal>
          </div>
          </div>
        </div>
      </CardHeader>
      <CardBody className='pt-0 campaign-table'>
        <div className='recent-table table-responsive currency-table'>
        <Fragment>
        {(selectedRows.length !== 0) &&
                <div className={`d-flex align-items-center justify-content-between bg-light-info p-2`}>
                    <H4 attrH4={{ className: 'text-muted m-0' }}>Delet Selected Data..!</H4>
                    <Btn attrBtn={{ color: 'danger', onClick: () => handleDelete() }}>Delete</Btn>
                </div>
            }
        <DataTable
                data={inventoryCategory.map(row => ({ ...row, LargeModaltoggle }))}
                columns={inventorytableColumns}
                striped={true}
                center={true}
                pagination
                selectableRows ={permission?.delete_access}
                onSelectedRowsChange={handleRowSelected}
                clearSelectedRows={toggleDelet}
            />
            </Fragment>
        </div>
      </CardBody>
    </Card>
  );
}

export default InventoryCategory